// extracted by mini-css-extract-plugin
export default {"container":"eC","productarea":"fC","btn":"gC","promowrapper":"hC","upsellarea":"iC","subtitle":"jC","system":"kC","desc":"lC","cardswrap":"mC","cards":"nC","squareloadingcontainer":"oC","squareloading33":"pC"};
    if(module.hot) {
      // 1715188236262
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  